import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';

import { Gallery } from '@designsystem/stories/04-organisms/Gallery';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

const ImageSliderView = (props) => {
  const { data } = props;
  const items = normalizeContent(data.slides ?? [], false, {
    '40rem': '50vw',
  });
  return <Gallery slider={data?.slider} items={items} />;
};

export default withBlockExtensions(ImageSliderView);
